// TODO : custom show pagelist with large totalPage

/**
*  @params {
*           totalPage: PropTypes.number,
*           totalRecord: PropTypes.number,
*           isDisableSelectSizePerPage: PropTypes.bool,
*           sizePerPageList: PropTypes.array,
*           onChange: PropTypes.func // call custom onChange from props with querryParams when page or sizePerPage change {size: this.state.size, page: this.state.currentPage}
*          }
*/

import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

class Pagination extends React.Component {
  static propTypes = {
    totalPage: PropTypes.number,
    totalRecord: PropTypes.number,
    isDisableSelectSizePerPage: PropTypes.bool,
    sizePerPageList: PropTypes.array,
    onChange: PropTypes.func,
    currentPage: PropTypes.number
  }

  static defaultProps = {
    currentPage: 1,
    totalPage: 1,
    totalRecord: 0,
    isDisableSelectSizePerPage: false,
    sizePerPageList: [10, 20, 30, 40, 50, 100]
  }

  static childContextTypes = {
    currentPage: PropTypes.number
  };

  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      sizePerPage: 10
    };
  }

  getChildContext() {
    return {currentPage: this.state.currentPage};
  }

  componentWillReceiveProps(nextProps) {
    // if (nextProps.totalPage !== this.props.totalPage || nextProps.totalRecord !== this.props.totalRecord) { // || nextProps.currentPage !== this.state.currentPage) {
    //   this.setState({currentPage: 1});
    // }

    if (nextProps.currentPage !== this.state.currentPage) {
      this.setState({ currentPage: nextProps.currentPage});
    }
  }

  onChangePage = currentPage => e => {
    e.preventDefault();

    if (currentPage !== '...') {
      this.setState({ currentPage }, () => {
        this.props.onChange({ size: this.state.sizePerPage, page: this.state.currentPage});
      });
    }

  }

  onChangeSizePerPage = sizePerPage => e => {
    e.preventDefault();
    this.setState({ sizePerPage, currentPage: 1 }, () => {
      this.props.onChange({ size: this.state.sizePerPage, page: this.state.currentPage});
    });
  }

  onClickNextPage = (e) => {
    e.preventDefault();
    this.setState({currentPage: this.state.currentPage + 1}, () => {
      this.props.onChange({ size: this.state.sizePerPage, page: this.state.currentPage});
    });
  }

  onClickPreviousPage = (e) => {
    e.preventDefault();
    this.setState({currentPage: this.state.currentPage - 1}, () => {
      this.props.onChange({ size: this.state.sizePerPage, page: this.state.currentPage});
    });
  }

  generalPageList = () => {
    const pageList = [];
    if (this.props.totalPage <= 7) {
      for (let i = 1; i <= this.props.totalPage; i++) {pageList.push(i);}
    }
    if (this.props.totalPage > 7 && this.props.totalPage < 20) {
      for (let i = 1; i <= 2; i++) {pageList.push(i);}
      if (this.state.currentPage < 3) {pageList.push('...');}
      if (this.state.currentPage > 2 && this.state.currentPage < this.props.totalPage - 2) {
        if (this.state.currentPage > 3) {pageList.push('...');}
        for (let i = this.state.currentPage; i <= this.state.currentPage + 1; i++) {pageList.push(i);}
        pageList.push('...');
      }

      if (this.state.currentPage > this.props.totalPage - 3) {pageList.push('...');}
      if (this.state.currentPage === this.props.totalPage - 2) {pageList.push(this.state.currentPage);}
      for (let i = this.props.totalPage - 1; i <= this.props.totalPage; i++) {pageList.push(i);}
    }
    if (this.props.totalPage > 20) {
      for (let i = 1; i <= 2; i++) {pageList.push(i);}
      if (this.state.currentPage < 3) {pageList.push('...');}
      if (this.state.currentPage > 2 && this.state.currentPage < this.props.totalPage - 2) {
        if (this.state.currentPage > 3) {pageList.push('...');}
        for (let i = this.state.currentPage; i <= this.state.currentPage + 1; i++) {pageList.push(i);}
        pageList.push('...');
      }

      if (this.state.currentPage > this.props.totalPage - 3) {pageList.push('...');}
      if (this.state.currentPage === this.props.totalPage - 2) {pageList.push(this.state.currentPage);}
      for (let i = this.props.totalPage - 1; i <= this.props.totalPage; i++) {pageList.push(i);}
    }
    return pageList;
  }

  renderPageList() {
    if (this.props.totalPage <= 1) {return null;}
    const pageList = this.generalPageList();

    return (
      <ul className='pagination' style={{ margin: 0}}>
        {
          this.state.currentPage !== 1 && <li className='page-item' title='previous page'><a href='#' onClick={this.onClickPreviousPage} className='page-link'>&lt;</a></li>
        }
        {
          _.map(pageList, (page, index) => {
            return (
              <li className={`${this.state.currentPage === page ? 'active' : ''} page-item`} title={page} key={index}>
                <a href='#' onClick={this.onChangePage(page)} className='page-link'>{page}</a>
              </li>
            );
          })
        }
        {
          this.state.currentPage !== this.props.totalPage && <li className='page-item' title='next page'><a href='#' onClick={this.onClickNextPage} className='page-link'>&gt;</a></li>
        }
      </ul>
    );
  }

  renderDropDownSizePerPage() {
    if (this.props.isDisableSelectSizePerPage || this.props.totalPage <= 1) {return null;}
    return (
      <div className='change-page-size pull-left'>
        <span className='info-per-page'>Show </span>
        <span className='item-per-page'>
          <span className='dropdown   react-bs-table-sizePerPage-dropdown' style={{visibility: 'visible'}}>
            <button className='btn btn-default btn-secondary dropdown-toggle' id='pageDropDown' data-toggle='dropdown' aria-expanded='false'>{this.state.sizePerPage}
              <span> <span className='caret' /></span>
            </button>
            <ul className='dropdown-menu' role='menu' aria-labelledby='pageDropDown'>
              {
                _.map(this.props.sizePerPageList, (item, index) => {
                  return (
                    <li role='presentation' className='dropdown-item' key={index}>
                      <a role='menuitem' tabIndex='-1' href='javascript:;' onClick={this.onChangeSizePerPage(item)}>{item}</a>
                    </li>
                  );
                })
              }
            </ul>
          </span></span><span className='info-per-page'> items / page </span>
      </div>
    );
  }

  render() {
    return (
      <div className='fs-paging clearfix'>
        <div className='col-md-5 col-sm-5 col-lg-4'>
          {this.renderDropDownSizePerPage()}
        </div>
        <div className='col-md-7 col-sm-7 col-lg-8'>
          <div className='page-list pull-right'>
            {this.renderPageList()}
          </div>
        </div>
      </div>
    );
  }
}

export default Pagination;



// WEBPACK FOOTER //
// ./src/components/pagination/index.js